import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from 'styled-components';

const OfficeHoursDisplay = ({ officeHours }) => {
  const theme = useTheme();

  if (!officeHours || officeHours.length === 0) {
    return null;
  }

  // Sort by day number
  const sortedHours = [...officeHours].sort((a, b) => a.day - b.day);

  return (
    <Box sx={{ mt: 0.5 }}>
      {sortedHours.map(dayHours => (
        <Box
          key={dayHours.day}
          sx={{
            display: 'flex',
            py: 0.25,
            alignItems: 'flex-start'
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              color: '#333',
              minWidth: '90px',
              fontWeight: 500
            }}
          >
            {dayHours.dayName}:
          </Typography>
          <Box>
            {dayHours.status === 'closed' ? (
              <Typography
                sx={{
                  fontSize: '12px',
                  color: theme?.text?.error || '#ff4d4f',
                  fontStyle: 'italic'
                }}
              >
                Closed
              </Typography>
            ) : dayHours.availability && dayHours.availability.length > 0 ? (
              dayHours.availability.map((slot, index) => (
                <Typography
                  key={index}
                  sx={{
                    fontSize: '12px',
                    color: theme?.text?.primary
                  }}
                >
                  {slot.startTime} - {slot.endTime}
                </Typography>
              ))
            ) : (
              <Typography
                sx={{
                  fontSize: '12px',
                  color: theme?.text?.primary
                }}
              >
                Open (hours not specified)
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default OfficeHoursDisplay;
